.wrapper {
  z-index: 1;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 13px;
  color: var(--color-text-secondary);

  &[data-context='default'] {
    padding: 20px 0;
  }

  &[data-context='multi-column'] {
    padding: 15px;
  }

  &[data-context='about'] {
    margin-top: 60px;
    text-align: center;
    font-size: 15px;
    line-height: 22px;

    &[data-redesign='false'] {
      @media screen and (width >= 1175px) {
        display: none;
      }
    }
  }
}

.heading {
  display: inline;
  margin-inline-end: 0.3em;
  font-weight: 500;
}

.list {
  display: inline;

  li {
    display: inline;

    &:not(:last-child)::after {
      content: ' · ';

      @supports (content: 'x' / 'y') {
        content: ' · ' / '';
      }
    }
  }

  a {
    color: var(--color-text-secondary);
    text-decoration: underline;

    &:hover,
    &:focus,
    &:active {
      text-decoration: none;
    }
  }
}

.version {
  white-space: nowrap;
}

.sponsor {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sponsor a {
  color: var(--color-text-secondary);

  &:hover,
  &:focus-visible {
    color: var(--color-text-primary);
  }
}

.logo {
  display: inline-block;
  width: 87px;
  height: 16px;
  vertical-align: middle;
  background-color: currentColor;
  mask-size: contain;
  mask-repeat: no-repeat;
  transition: color 0.2s;
}
